import Technology from './Technology'

export default Technology
